import { Outlet, useNavigate, useOutletContext } from "react-router";
import { useRootLoader } from "@/hooks/useRootLoader";
import { checkSystemRoleAtLeast } from "@/utils/role";
import { ROUTE_403 } from "@/utils/const";
import { useEffect } from "react";
import type { SystemRole } from "@shared-domain/unizo/permissions";

/**
 * システム軸の段で絞るルートのガード（PRODUCT_DEV-1235 で段を受け取る形にした）。
 *
 * - `min="sysadmin"` … admin + specialFlags["sysadmin"]（プリセット・リアルタイム API など）
 * - `min="admin"` … 管理ユーザー以上（ユーザー管理・セキュリティ設定）
 *
 * ⚠ ここは表示の出し分けだけ。認可の正はサーバ（同じ表で判定する）。
 */
export function SystemRoleGuard({ min }: { min: SystemRole }) {
  const { auth } = useRootLoader();
  const navigate = useNavigate();
  const context = useOutletContext();
  const allowed = checkSystemRoleAtLeast(auth, min);

  useEffect(() => {
    if (!allowed) {
      navigate(ROUTE_403, { replace: true });
    }
  }, [allowed, navigate]);

  if (!allowed) {
    return null;
  }

  return <Outlet context={context} />;
}

/** sysadmin 限定ルートのガード（admin + specialFlags["sysadmin"]）。 */
export function SysadminGuard() {
  return <SystemRoleGuard min="sysadmin" />;
}
